export class QueryParameter {
    private param: string;
    private value: string;

    constructor(param: string, val: string) {
        this.param = param;
        this.value = val;
    }

    get Param(): string { return this.param; }
    set Param(value: string) { this.param = value; }

    get Value(): string { return this.value; }
    set Value(value: string) { this.value = value; }
}
